import { ThemeConfig } from "@cede/utils";

export const globalStyle = (theme: ThemeConfig) => `
  * {
    color: ${theme.palette.text.primary};
    font-family: ${theme.typography(theme.palette).fontFamily};
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .cede-layout {
    position: relative;
    overflow: hidden;
    max-width: ${theme.custom.storeSize.widgetMaxWidth};
    min-width: ${theme.custom.storeSize.widgetMinWidth};
    background: ${theme.palette.background.default};
    width: ${theme.custom.storeSize.widgetWidth};
    height: ${theme.custom.storeSize.widgetHeight};
    border-radius: 12px;
    padding: 12px;
    border: 1px solid transparent;
  }

  .component-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
  }

  .cede-button {
    height: 50px;
    border-radius: 14px;
    background: ${theme.palette.primary.main};
    color: ${theme.palette.text.primary};
    border: none;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
    width: 100%;
    font-size: ${theme.typography(theme.palette).body1.fontSize};
  }

  .icon-button {
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .cede-logo, .cede-logo * {
    color: ${theme.palette.logoBorderColor};
    display: inline-block;
  }

  .animate-exit {
    z-index: 2;
    animation: fade-out .5s ease-in forwards;
  }

  @keyframes fade-out {
    from { opacity: 1; }
    to { opacity: 0; }
  }

  @keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
